// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedInDiscoveryPage-cls1__kS","cls2":"LoggedInDiscoveryPage-cls2_TWm LoggedInDiscoveryPage-cls1__kS"};